import { browserLocalPersistence, setPersistence } from "firebase/auth";
let persistenceSet = false;

export const ensurePersistence = (auth) => {
  if (persistenceSet) return Promise.resolve();
  persistenceSet = true;
  return setPersistence(auth, browserLocalPersistence);
};
